var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg444Bf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.955 160.303H147.703V235.05H72.955z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.328 264.949H148.07600000000002V339.696H73.328z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.516 369.595H148.263V444.343H73.516z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.861 55.657H147.608V130.405H72.861z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M414.75 249.918c4.929-76.658 73.935-190.163-58.733-190.163-111.138 0-118.596 96.192-118.596 190.163 0 84.969 4.044 186.586 106.526 190.163 142.872 4.986 76.281-104.975 70.803-190.163z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg444Bf);
export default __webpack_public_path__ + "static/media/444bf.8f9b06c5bb5bd3f2a0abf6aeda29e831.svg";
export { ForwardRef as ReactComponent };